
<app-modal [(visible)]="visible"
           [header]="moveType"
           (visibleChange)="visibleChange.emit($event)"
           (onShow)="open()"
           (onHide)="close()">
  <div></div>
  <form [formGroup]="formGroupContact">

    <div class="p-fluid address-search">
      <div class="p-grid p-col-12 p-md-12 p-lg-12">
        <div class="p-col-6 p-md-6 p-lg-6">
          <form-factory [formGroup]="formGroupContact" [model]="contactName"></form-factory>
        </div>
        <div class="p-col-6 p-md-6 p-lg-6">
          <form-factory [formGroup]="formGroupContact" [model]="groupName"></form-factory>
        </div>
      </div>
      <div class="p-grid p-col-12 p-md-12 p-lg-12">
        <div class="p-col-6 p-md-6 p-lg-6">
          <form-factory [formGroup]="formGroupContact" [model]="email"></form-factory>
        </div>
        <div class="p-col-6 p-md-6 p-lg-6">
          <form-factory [formGroup]="formGroupContact" [model]="phone"></form-factory>
        </div>
      </div>
      <div class="p-grid p-col-12 p-md-12 p-lg-12">
        <div class="p-col-6 p-md-6 p-lg-6">
          <form-factory [formGroup]="formGroupContact" [model]="fax"></form-factory>
        </div>
        <div class="p-col-6 p-md-6 p-lg-6">
          <form-factory [formGroup]="formGroupContact" [model]="preferredRequestMethod"></form-factory>
        </div>
      </div>

      <div class="p-grid p-col-12 p-md-12 p-lg-12 text-center">
        <div class="p-col-1 p-md-1 p-lg-1"></div>
        <div class="p-col-3 p-md-3 p-lg-3">
          <label class="call-script__label text-center">Commitment Date:</label>
        </div>
        <div class="p-col-5 p-md-5 p-lg-5 no-padding">
          <p-calendar [showIcon]=true
            appendTo="body"
            [readonlyInput]="true"
            [hideOnDateTimeSelect]="true"
            class="appointment__input"
            placeholder="Date"
            [(ngModel)]="commitmentDate"
            [ngModelOptions]="{standalone: true}"
            [minDate]="minDate">
            </p-calendar>
          </div>
      </div>
    </div>
    
  </form>

  <div class="notes-error" *ngIf="notesMissing">
    Enter Notes for chase move.
  </div>

  <textarea 
    class="notes-textarea" 
    placeholder="Enter Notes for Chase Move." 
    [(ngModel)]="notesText"
    (keyup)="onNotesTextChange()">
  </textarea>

  <div class="inherit-option-checkbox" *ngIf="isMoveChaseVisible">
    <form-factory
      [formGroup]="formGroupContact"
      [model]="inheritChaseInput">
    </form-factory>
  </div>

  <div class="inherit-option-checkbox" *ngIf="isMoveChaseVisible">
    <form-factory
      [formGroup]="formGroupContact"
      [model]="inheritContactHistoryInput">
    </form-factory>
  </div>

  <footer>
    <app-button class="header-button" text="Move Chases" (onClick)="moveChases()"></app-button>
  </footer>
</app-modal>
